/* eslint-disable no-unreachable */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { creatFolder } from '../../actions/media_actions';
import { toast } from 'react-toastify';
import { setMediaKitData } from '../../../redux/MediakitRedux';
import { useParams } from 'react-router-dom';
import { catchErr } from '../../../libs/HelperContent';

const useUpload = (oldData) =>
{
	const userData = useSelector((state: any) => state.mysession.session);
	const dispatch = useDispatch();
	const { tab } = useParams();

	const setData = (data) =>
	{
		if (tab === 'folder')
		{
			const newData:any = { ...data[0] };

			// if (fileData?.hasOwnProperty('updateExist') && fileData?.updateExist)
			// {
			// 	prevData = mediaRef?.current?.oldData.map((item) => (item?.name === fileData?.name ? { ...item, ...newData, media: fileData?.type === 'folder' ? {} : newData, updatedAt: new Date() } : item));
			// }
			// else
			// {
			const prevData = [ newData, ...oldData ];
			// }

			dispatch(setMediaKitData(({ folderData: [ ...prevData ] })));
		}
	};

	const handleUploadFiles = async (media, parentId) =>
	{
		const query: any = { uid: userData?.userId, comid: userData?.companyId, empRole: userData?.empRole, role: userData?.role };

		const body: any = {
			type   : 1,
			parent : tab === 'folder' ? parentId : ''
		};

		body.newData = media;

		try
		{
			const res = await creatFolder(query, body);

			if (res?.status)
			{
				setData(res?.data);

				return res;
			}
		}
		catch (err)
		{
			catchErr(err);
		}
	};

	return handleUploadFiles;
};

export default useUpload;